module.exports = __webpack_public_path__ + "img/service_backend_4_2x.ef73f810.jpg";